export default "__VITE_ASSET__C4cpAO8u__"